<template>
  <v-tooltip
    v-model="show"
    position="right"
    z-index="1100"
    class="rounded"
    max-width="135px"
    aria-label="Информация по фильтру"
  >
    <!-- isFilterActivator -->
    <template v-if="!isOffer" v-slot:activator="{props}">
      <v-row
        class="d-flex header-text-filter-tooltip mb-0"
        no-gutters
      >
        <v-col cols="11" class="d-flex align-end">
          <v-row style="position: relative;" no-gutters>
            <v-col
              :class="{'text-no-wrap': isGlassType, 'bg-white': !isGlassType }"
              class="d-flex v-col-auto header-column"
            >
              <slot name="header"></slot>
            </v-col>

            <div class="d-flex align-self-end container-dt justify-end">
               <div class="dt-filter-tooltip"></div>
            </div>
          </v-row>

        </v-col>
        <v-col
          cols="1"
          class="d-flex justify-center align-end tooltip-icon"
        >
          <div
            @mouseover="show=true"
            v-bind="props"
            @click.stop
            class="bg-white"
            :class="{'icon-circle': !icon}"
          >
            <v-icon v-if="icon"
                    :class="icon"
                    style="margin-left: -1px !important; z-index: 1;;"
                    class="grey-icon icon-custome mt-n1" />
            <v-icon v-else class="grey-icon icon-info">{{ mdiInformationVariant }}</v-icon>
          </div>
        </v-col>
      </v-row>
    </template>

    <!-- isFilterActivator -->
    <!-- isOfferActivator -->
    <template v-else v-slot:activator="{props}">
      <div
        @mouseover="show=true"
        v-bind="props"
        @click.stop
        class="bg-white"
      >
        <slot name="header"></slot>
      </div>
    </template>
    <!-- isOfferActivator -->

    <!-- TooltipContent -->
    <div
      v-if="item"
    >
      <span v-if="item.description">{{ item.description }}</span>
      <template v-if="item.description_content && !isOffer">
        <v-img width="160" class="rounded" v-if="item.description_content.image_url" :src="item.description_content.image_url"></v-img>
        <span v-if="item.description_content.text_second">{{ item.description_content.text_second }}</span>
        <a v-if="item.description_content.url_more" target="_blank" rel="noopener" :href="item.description_content.url_more">Подробнее...</a>
      </template>
    </div>
    <!-- TooltipContent -->

  </v-tooltip>
</template>

<script>
import axios from 'axios';

import "../../scss/components/FiltersTooltip.scss";
import { mdiInformationVariant } from '@mdi/js';

export default {
  name: "FiltersTooltip",
  props: ["code","icon","isGlassType","isFullconstruction","isOffer"],
  data () {
    return {
      active: false,
      load_data: false,
      item: undefined,
      mdiInformationVariant,
      hoverTimer: null,
      last_scroll_y: null,
      show: false
    }
  },
  watch: {
    show(val) {
      if (val) this.loadData();
    }
  },
  methods: {
    loadData() {
      this.load_data = true;
      axios.get('/api/calculator/get_hint.json', {params: { code: this.code } }).then(response => {
        this.item = response.data
      })
    },
  },
};
</script>
